import { easyPost } from './request';

export const getCaptcha = easyPost('/auth/getCaptcha', {
  // mockData: {
  //   code: 0,
  // },
});

export const login = easyPost('/auth/login', {
  // mockData: {
  //   code: 0,
  //   data: {
  //     token: '1223r2rsfsf',
  //   },
  // },
});

export const getUserList = easyPost('/admin/getUsers', {
  // mockData: {
  //   data: [
  //     {
  //       userName: '张三',
  //       phoneNumber: '12300000000',
  //       email: '11@163.com',
  //       userType: 0,
  //       platform: 3,
  //       comments: 'sfjoifsjfsfjoifsjfsfjoifsjfsfjoifsjf',
  //     },
  //   ],
  // },
});

export const getOrdermanList = easyPost('/admin/getOrderManList', {
  // mockData: {
  //   code: 0,
  //   data: [],
  // },
});

export const addOrUpdateUser = easyPost('/admin/editUser', {});

export const deleteUser = easyPost('/admin/deleteUser', {});
